

















import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component
export default class ShareJumpComponent extends Vue {
  private isKkTalk = false

  private mounted() {
    const { platform } = this.$route.query;
    if (platform === 'KkTalk') {
      this.isKkTalk = true;
    }
  }

  private sendKkTalkLink() {
    const { link } = this.$route.query;
    try {
      if (Kakao && !Kakao.isInitialized()) {
        Kakao.init('1ff77dc0996d57d5f7979d0d301e7c64');
      }
    } finally {
      Kakao.Link.sendDefault({
        objectType: 'feed',
        content: {
          title: link,
          description: '',
          imageUrl: '',
          link: {
            mobileWebUrl: link,
            webUrl: link,
          },
        },
      });
    }
    const androidLinkurl = 'https://play.google.com/store/apps/details?id=com.kakao.talk';
    const iosLinkUrl = 'https://apps.apple.com/us/app/kakaotalk/id362057947';

    const timer = setTimeout(() => {
      this.initDownloadApp(iosLinkUrl, androidLinkurl);
    }, 3000);

    const visibilitychange = () => {
      const tag = document.hidden || document.webkitHidden;
      if (tag) {
        clearTimeout(timer);
      }
    };

    document.addEventListener('visibilitychange', visibilitychange, false);
    document.addEventListener('webkitvisibilitychange', visibilitychange, false);
    window.addEventListener(
      'pagehide',
      () => {
        clearTimeout(timer);
      },
      false,
    );
  }

  private initDownloadApp(iosLinkUrl: string, androidLinkurl: string) {
    if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
      window.location.href = iosLinkUrl;
    } else if (navigator.userAgent.match(/android/i)) {
      window.location.href = androidLinkurl;
    }
  }
}
